module.exports = __webpack_public_path__ + "img/scrmT4.711f197f.png";